import {createTheme} from "@mui/material/styles"


export const GympinTheme = createTheme({
    direction: 'rtl',
    defaultColorScheme: 'light',
    cssVariables: {
        colorSchemeSelector: '.mode-%s',
    },
    colorSchemes: {
        light: {
            palette: {
                background: {
                    default: '#f8f8f8',
                    paper: '#ffffff',
                },
                text: {
                    primary: '#171717',
                    secondary: '#737373',
                    disabled: '#a3a3a3',
                },
                divider: 'rgba(0, 0, 0, 0.08)',
                action: {
                    hover: 'rgba(0, 0, 0, 0.04)',
                    selected: 'rgba(0, 0, 0, 0.08)',
                },
                appbar: {
                    light: '#c7c7c7',
                    main: '#ffffff',
                    dark: '#9b9b9b',
                    contrastText: '#4f4f4f',
                },
                manuBadge: {
                    light: '#c7c7c7',
                    main: '#911212',
                    dark: '#9b9b9b',
                    contrastText: '#ffffff',
                },
                gray: {
                    light: '#efefef',
                    main: '#e9e9e9',
                    dark: '#afafaf',
                    darker: "#333333",
                    contrastText: '#4f4f4f',
                },
                primary: {
                    light: '#f14651',
                    main: '#e7333e',
                    dark: '#b22831',
                    contrastText: '#ffffff',
                }
            }
        },
        dark: {
            palette: {
                background: {
                    default: '#121212',
                    paper: '#1e1e1e',
                },
                text: {
                    primary: '#f5f5f5',
                    secondary: '#a3a3a3',
                    disabled: '#737373',
                },
                divider: 'rgba(255, 255, 255, 0.08)',
                action: {
                    hover: 'rgba(255, 255, 255, 0.05)',
                    selected: 'rgba(255, 255, 255, 0.10)',
                },
                appbar: {
                    light: '#3a3a3a',
                    main: '#1e1e1e',
                    dark: '#121212',
                    contrastText: '#ffffff',
                },
                manuBadge: {
                    light: '#f87171',
                    main: '#e7333e',
                    dark: '#b22831',
                    contrastText: '#ffffff',
                },
                gray: {
                    light: '#282828',
                    main: '#383838',
                    dark: '#525252',
                    darker: "#f5f5f5",
                    contrastText: '#f5f5f5',
                },
                primary: {
                    light: '#f14651',
                    main: '#e7333e',
                    dark: '#b22831',
                    contrastText: '#ffffff',
                }
            }
        }
    },
    direction: "rtl",
    components: {
        MuiListItemIcon: {
            styleOverrides: {
                root: {
                    minWidth: 30,
                }
            }
        },
        MuiDialog:{
            styleOverrides:{
                paper:{
                    borderRadius:12,
                }
            }
        },
        MuiCard: {
            defaultProps:{
                variant:"outlined"
            },
            styleOverrides: {
                root: {
                    borderRadius: 12
                },
            }

        },
        MuiButton: {
            styleOverrides: {
                root: {
                    borderRadius: 12,
                }
            }
        },
        MuiAlert: {
            styleOverrides: {
                root: {
                    borderRadius: 12,
                }
            }
        },
        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    borderRadius: 12
                }
            }
        }
    },
    typography: {
        fontFamily: "IRANSans-web",
        fontSize: 12,
        h1: {
            fontFamily: "IRANSans-web",
            fontSize: "2rem",
        },
        h2: {
            fontFamily: "IRANSans-web",
            fontSize: "1.8rem",
        },
        h3: {
            fontFamily: "IRANSans-web",
            fontSize: "1.55rem",
        },
        h4: {
            fontFamily: "IRANSans-web",
            fontSize: "1.4rem",
        },
        h5: {
            fontFamily: "IRANSans-web",
            fontSize: "1.2rem",
        },
        h6: {
            fontFamily: "IRANSans-web",
            fontSize: "1.1rem",
        },
        subtitle1: {
            fontFamily: "IRANSans-web",
            fontSize: "0.95rem",
        },
        subtitle2: {
            fontFamily: "IRANSans-web",
            fontSize: "0.90rem",
        },
        body1: {
            fontFamily: "IRANSans-web",
            fontSize: "0.85rem",
        },
        body2: {
            fontFamily: "IRANSans-web",
            fontSize: "0.80rem",
        },
        caption: {
            fontFamily: "IRANSans-web",
            fontSize: "0.75rem",
        },
        overline: {
            fontFamily: "IRANSans-web",
            fontSize: "0.6rem",
        },
    }
})
